import React from 'react';


const TechIcons = () =>{
    return(
            <section id="tech_icons"  className="section tech_icons"  data-aos-delay="200">
            <div className="container-fluid"  data-aos="fade-up">
            <div className="row">
            <div className="col-md-1">
            <img data-bs-toggle="tooltip" data-bs-placement="top" title="PHP" src="assets/tech-icons/php.svg" className="img-fluid" alt="" />
            </div>
            <div className="col-md-1">
            <img data-bs-toggle="tooltip" data-bs-placement="top" title="MySQL" src="assets/tech-icons/mysql.svg" className="img-fluid" alt="" />
            </div>
            <div className="col-md-1">
            <img data-bs-toggle="tooltip" data-bs-placement="top" title="PostgreSQL" src="assets/tech-icons/PostgreSQL.svg" className="img-fluid" alt="" />
            </div>            
            <div className="col-md-1">
            <img data-bs-toggle="tooltip" data-bs-placement="top" title="Apache HTTP Server" src="assets/tech-icons/apache.svg" className="img-fluid" alt="" />
            </div>            
            <div className="col-md-1">
            <img data-bs-toggle="tooltip" data-bs-placement="top" title="GeoServer - web server" src="assets/tech-icons/geoserver.png" className="img-fluid" alt="" />
            </div>
            <div className="col-md-1">
            <img data-bs-toggle="tooltip" data-bs-placement="top" title="HTML5" src="assets/tech-icons/html-5.svg" className="img-fluid" alt="" />
            </div>  
            <div className="col-md-1">
            <img data-bs-toggle="tooltip" data-bs-placement="top" title=" Cascading Style Sheets Level 3" src="assets/tech-icons/css3.svg" className="img-fluid" alt="" />
            </div>  
            <div className="col-md-1">
            <img data-bs-toggle="tooltip" data-bs-placement="top" title="JavaScript" src="assets/tech-icons/javascript.svg" className="img-fluid" alt="" />
            </div>
            <div className="col-md-1">
            <img data-bs-toggle="tooltip" data-bs-placement="top" title="Node Package Manager" src="assets/tech-icons/npm.svg" className="img-fluid" alt="" />
            </div>             
            <div className="col-md-1">
            <img data-bs-toggle="tooltip" data-bs-placement="top" title="Node.js" src="assets/tech-icons/node.svg" className="img-fluid" alt="" />
            </div>            
            <div className="col-md-1">
            <img data-bs-toggle="tooltip" data-bs-placement="top" title="AngularJS" src="assets/tech-icons/angularjs.svg" className="img-fluid" alt="" />
            </div> 
            <div className="col-md-1">
            <img data-bs-toggle="tooltip" data-bs-placement="top" title="React" src="assets/tech-icons/reactjs.svg" className="img-fluid" alt="" />
            </div>
            </div>
            <div className="row">
            <div className="col-md-1">
            <img data-bs-toggle="tooltip" data-bs-placement="top" title="Babel-JavaScript compiler" src="assets/tech-icons/babel.svg" className="img-fluid" alt="" />
            </div>
            <div className="col-md-1">
            <img data-bs-toggle="tooltip" data-bs-placement="top" title="jQuery" src="assets/tech-icons/jquery.svg" className="img-fluid" alt="" />
            </div>
            <div className="col-md-1">
            <img data-bs-toggle="tooltip" data-bs-placement="top" title="OpenLayers" src="assets/tech-icons/openlayers.svg" className="img-fluid" alt="" />
            </div>            
            <div className="col-md-1">
            <img data-bs-toggle="tooltip" data-bs-placement="top" title="TypeScript" src="assets/tech-icons/typescript.svg" className="img-fluid" alt="" />
            </div>            
            <div className="col-md-1">
            <img data-bs-toggle="tooltip" data-bs-placement="top" title="Vue.js" src="assets/tech-icons/vuejs.svg" className="img-fluid" alt="" />
            </div>
            <div className="col-md-1">
            <img data-bs-toggle="tooltip" data-bs-placement="top" title="Docker" src="assets/tech-icons/docker.svg" className="img-fluid" alt="" />
            </div>
            <div className="col-md-1">
            <img data-bs-toggle="tooltip" data-bs-placement="top" title="PhpStorm" src="assets/tech-icons/phpstorm.svg" className="img-fluid" alt="" />
            </div>
            <div className="col-md-1">
            <img data-bs-toggle="tooltip" data-bs-placement="top" title="Redis" src="assets/tech-icons/redis.svg" className="img-fluid" alt="" />
            </div>
            <div className="col-md-1">
            <img data-bs-toggle="tooltip" data-bs-placement="top" title="Laravel" src="assets/tech-icons/laravel.svg" className="img-fluid" alt="" />
            </div>
            <div className="col-md-1">
            <img data-bs-toggle="tooltip" data-bs-placement="top" title="WordPress" src="assets/tech-icons/wordpress.svg" className="img-fluid" alt="" />
            </div>
            <div className="col-md-1">
            <img data-bs-toggle="tooltip" data-bs-placement="top" title="CodeIgniter" src="assets/tech-icons/codeigniter.svg" className="img-fluid" alt="" />
            </div>
            <div className="col-md-1">
            <img data-bs-toggle="tooltip" data-bs-placement="top" title="Joomla Content Management System" src="assets/tech-icons/joomla.svg" className="img-fluid" alt="" />
            </div>
            </div>

            <div className="row">
            <div className="col-md-1">
            <img data-bs-toggle="tooltip" data-bs-placement="top" title="Figma: The Collaborative Interface Design Tool" src="assets/tech-icons/figma.svg" className="img-fluid" alt="" />
            </div>
            <div className="col-md-1">
            <img data-bs-toggle="tooltip" data-bs-placement="top" title="Linux" src="assets/tech-icons/linux.svg" className="img-fluid" alt="" />
            </div>    
            <div className="col-md-1">
            <img data-bs-toggle="tooltip" data-bs-placement="top" title="JavaScript Object Notation (JSON)" src="assets/tech-icons/json.svg" className="img-fluid" alt="" />
            </div>    
            <div className="col-md-1">
            <img data-bs-toggle="tooltip" data-bs-placement="top" title="Microsoft Windows" src="assets/tech-icons/windows.svg" className="img-fluid" alt="" />
            </div>                         
            <div className="col-md-1">
            <img data-bs-toggle="tooltip" data-bs-placement="top" title="Bootstrap" src="assets/tech-icons/bootstrap.svg" className="img-fluid" alt="" />
            </div>  
            <div className="col-md-1">
            <img data-bs-toggle="tooltip" data-bs-placement="top" title="Trello" src="assets/tech-icons/trello.svg" className="img-fluid" alt="" />
            </div>   
            <div className="col-md-1">
            <img data-bs-toggle="tooltip" data-bs-placement="top" title="Jira | Issue & Project Tracking Software" src="assets/tech-icons/jira.svg" className="img-fluid" alt="" />
            </div> 
            <div className="col-md-1">
            <img data-bs-toggle="tooltip" data-bs-placement="top" title="Azure DevOps Services" src="assets/tech-icons/azure-devops-color.svg" className="img-fluid" alt="" />
            </div>
            <div className="col-md-1">
            <img data-bs-toggle="tooltip" data-bs-placement="top" title="Git" src="assets/tech-icons/git.svg" className="img-fluid" alt="" />
            </div>
            <div className="col-md-1">
            <img data-bs-toggle="tooltip" data-bs-placement="top" title="Secure Shell (SSH) protocol" src="assets/tech-icons/ssh.svg" className="img-fluid" alt="" />
            </div>
            <div className="col-md-1">
            <img data-bs-toggle="tooltip" data-bs-placement="top" title="Microsoft Teams" src="assets/tech-icons/microsoft-teams.svg" className="img-fluid" alt="" />
            </div>
            <div className="col-md-1">
            <img data-bs-toggle="tooltip" data-bs-placement="top" title="Tailwind CSS" src="assets/tech-icons/tailwind-css.svg" className="img-fluid" alt="" />
            </div>
            </div>
            </div>
            </section>
    );
}

export default TechIcons;
